import { accountApi } from "../../features/shared/api/accountApi"

export const getFullUserName = async (
  userId?: string,
  haAdminText?: string,
): Promise<string> => {
  if (!userId) return ""

  try {
    let fullName = ""
    const userAccount = await accountApi.get.USERNAME_BY_USER_ID({
      userId,
    })
    if (!!userAccount) {
      const uploadedByName = userAccount.isHaUser
        ? haAdminText
        : [userAccount.firstName, userAccount.lastName]
            .filter(Boolean)
            .join(" ")
      fullName = uploadedByName ?? ""
    }

    return fullName
  } catch (error) {
    throw new Error(`Error fetching full user name: ${error}`)
  }
}

export const getUniqueFullUserNamesMap = async (
  userIds: string[],
  haAdminText?: string,
): Promise<Record<string, string>> => {
  const userIdToFullNameMap: Record<string, string> = {}
  const uniqueUserIds = Array.from(new Set(userIds))

  if (uniqueUserIds.length === 0) {
    return userIdToFullNameMap
  }

  const userAccounts = await accountApi.post.USERNAMES_BY_USER_IDS({
    userIds: uniqueUserIds,
  })

  userAccounts.forEach((userAccount) => {
    if (userAccount) {
      userIdToFullNameMap[userAccount.userId] = userAccount.isHaUser
        ? haAdminText || ""
        : [userAccount.firstName, userAccount.lastName]
            .filter(Boolean)
            .join(" ")
    }
  })

  // TODO: we could add a slice and reducer call here that store all unique ids to full usernames

  return userIdToFullNameMap
}
